export const formatQty = qty => {
    const number = Number(qty || 0);
    return Number.isInteger(number) ? String(number) : number.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
};

export const formatDateTime = value => {
    if(!value || value === "0000-00-00 00:00:00") return "";
    const raw = String(value).trim();
    let date;
    const sqlMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
    if(sqlMatch && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)){
        const [, year, month, day, hour, minute, second = "00"] = sqlMatch;
        date = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
    }else{
        date = new Date(raw.replace(" ", "T"));
    }
    if(Number.isNaN(date.getTime())) return value;
    const pad = number => String(number).padStart(2, "0");
    const hours24 = date.getHours();
    const hours12 = hours24 % 12 || 12;
    const ampm = hours24 >= 12 ? "PM" : "AM";
    return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${pad(hours12)}:${pad(date.getMinutes())} ${ampm}`;
};

export const userLabel = user => user?.userName?.trim() || user?.email || "";

export const userOptionLabel = user => {
    const label = userLabel(user);
    return user?.email && label && label !== user.email ? `${label} (${user.email})` : label;
};

export const userEmailFromText = (users, value) => {
    const trimmed = String(value || "").trim();
    const lower = trimmed.toLowerCase();
    const match = users.find(user => user.email?.toLowerCase() === lower || userLabel(user).toLowerCase() === lower || userOptionLabel(user).toLowerCase() === lower);
    return match?.email || "";
};

export const isPositiveQuantityText = value => value !== "" && isFinite(Number(value)) && Number(value) > 0;
